// extracted by mini-css-extract-plugin
module.exports = {"counter_wrapper":"countdown_timer_counter_wrapper__1_1Lm","counter_num":"countdown_timer_counter_num__3omge","counter_txt":"countdown_timer_counter_txt__aqArD"};